






























































































































































































































































































































/*
  getParam 获取评卷聘用管理页面参数
  getMarkEmployMag 评卷聘用管理-省分页列表
  updateEmployStatus 确认或作废聘用
  createOffer 生成聘书
  openCheck 开放查看
  formalReleaseEmploy 正式发布聘用
  printOffer 打印聘书
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getMarkEmployMag,
  updateEmployStatus,
  createOffer,
  openCheck,
  formalReleaseEmploy,
  printOffer,
  getEmpolyNum
} from "../../../api/markingEmployManage";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

interface CurrentInfo {
  [propName: string]: any;
}

@Component({
  name: "markingEmployManage",
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private pdfUrl = '' //pdf地址
  private projectId: string = ""; //项目id
  private professionalId: string = "";//职称id
  private otherinfoHaveRelatives: string = ""; //是否近亲或利害关系人参加高考
  private otherinfoRecommendRole: string = "";//推荐岗位
  private otherinfoLastMarkingTimes: number | null = null;
  private districtId: string = "";//市县id
  private genderId: string = "";//性别id
  private gradeId: string = "";//任课年级id
  private schoolName: string = "";//所属单位
  private teachingAge : number | null = null;//教龄
  private projectLabel: string = ""; //项目展示标签
  private subjectId: string = ""; //科目id
  private isOpen: string = ""; //是否开放查看
  private isCreate: string = ""; //是否生成聘书
  private isRelease: string = ""; //是否正式聘用
  private employStatus: string = ""; //聘用状态
  private isApply: string = ""; //是否申请
  private teacherName: string = ""; //评卷教师
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private chooseRowArray: object[] = []; //勾选的数据row 集合
  private showContract: boolean = false; //是否显示"聘书"弹窗
  private currentInfo: CurrentInfo = {}; //当前勾选的单条数据（打印聘书窗口的数据）
  //页面参数
  private projects: object[] = []; //项目数组
  private subjects: object[] = []; //科目数组
  private professionals: object[] = []; //职称数组
  private districts: object[] = [];//市县
  private genders: object[] = [];//性别
  private grades: object[] = [];//任课年级
  private fullscreenLoading: boolean = false; //spin toggle
  private markStatistic: object = { total: "", choosed: "" }; //总评卷人数和已聘用人数统计
  private showAdvancedSearch: boolean = false; //是否显示高级筛选
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };

  private iframe:any = null  //装载pdf的iframe对象

  created() {
    //初始化data数据
    this.initDta();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

   beforeDestroy() {
    // 释放文件引用
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }
  }

  initDta() {
    const { projectLabel, projectId } = this.$route.query;
    if (projectLabel && projectId) {
      this.projectId = projectId as string;
      this.projectLabel = projectLabel as string;
    }
  }

  private getObjectURL(file) {
      let url: any = null;
      if (window['createObjectURL'] != undefined) { // basic
          url = window['createObjectURL'](file);
      } else if (window['webkitURL'] != undefined) { // webkit or chrome
          try {
            url = window['webkitURL'].createObjectURL(file);
          } catch (error) {

          }
      } else if (window.URL != undefined) { // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) {

        }
      }
      return url;
    }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data.projects;
      this.subjects = res.data.subjects;
      this.professionals = res.data.professionals;
      this.districts = res.data.districts;
      this.genders = res.data.genders;
      this.grades = res.data.grades;
    } catch (error) {
      this.$message.error(error || "获取数据失败");
      // this[`$message`]({
      //   type: "error",
      //   message: error!.mesg ? error!.mesg : error
      // });
    }
  }

  //getMarkEmployMag 和 exportMarkingEmployManage 接口的参数
  private getRequestParams() {
    return {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      employApplyState: this.isApply, //是否申请 0:否 1:是
      employIsOpen: this.isOpen, //开放查看 0:否 1:是
      isCreate: this.isCreate, //生成聘书 0:否 1:是
      employIsRelease: this.isRelease, //正式发布聘用 0:否 1:是
      employState: this.employStatus, //聘用状态 0:已聘用 1:作废聘用
      projectId: this.projectId, //项目id
      subjectId: this.subjectId, //科目id
      teacherName: this.teacherName, //教师姓名
      otherinfoLastMarkingTimes: this.otherinfoLastMarkingTimes,//最近三年参加高考评卷次数
      otherinfoHaveRelatives: this.otherinfoHaveRelatives,//是否近亲或利害关系人参加高考
      otherinfoRecommendRole: this.otherinfoRecommendRole,//推荐岗位
      districtId: this.districtId,//市县
      genderId: this.genderId,//性别
      gradeId: this.gradeId,//任教年级
      schoolName: this.schoolName,//所属单位
      teachingAge: this.teachingAge //教龄
    };
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let projectId = this.projectId
      let res = await getMarkEmployMag(this.getRequestParams());
      let num = await getEmpolyNum(projectId);
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
      this.markStatistic = num.data;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //重置搜索条件
  private resetSearch() {
    this.projectId = "";
    this.subjectId = "";
    this.districtId = "";
    this.employStatus = "";
    this.teacherName = "";
    this.professionalId = "";
    this.genderId = "";
    this.gradeId = "";
    this.schoolName = "";
    this.teachingAge = null;
    this.otherinfoLastMarkingTimes = null;
    this.otherinfoHaveRelatives = "";
    this.otherinfoRecommendRole = "";
    this.isOpen = "";
    this.isCreate = "";
    this.isRelease = "";
    this.isApply = "";
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    //记录勾选时的单条数据
    this.currentInfo = v[0];
    //保存勾选的教师id
    this.chooseIdArray = v.map((item: any) => {
      return item.teacherId;
    });
    // 勾选的单行的内容 -- 用于打印优秀证书
    this.chooseRowArray = [...v];
  }

  //操作校验(项目、科目、数据勾选)
  private operationCheck() {
    if (!this.projectId) {
      this.$message.warning("请选择项目！");
      return false;
    } else if (!this.subjectId) {
      this.$message.warning("请选择科目！");
      return false;
    } else if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选！");
      return false;
    } else {
      return true;
    }
  }

  private handleParams(type?) {
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return false;
    }
    let tempArr: Array<object> = [];
    if (type == "0" || type == "1") {
      // 确认聘书 和 作废聘书处理
      this.chooseRowArray.forEach(v => {
        tempArr.push({
          employState: type, //聘用状态 0:确认 1:作废
          projectId: v[`projectId`], //项目id
          subjectId: v[`subjectId`], //科目id
          teacherId: v[`teacherId`] //教师id
        });
      });
    } else {
      // 其他
      this.chooseRowArray.forEach(v => {
        tempArr.push({
          projectId: v[`projectId`], //项目id
          subjectId: v[`subjectId`], //科目id
          teacherId: v[`teacherId`] //教师id
        });
      });
    }

    return tempArr;
  }
  //“确认聘用”、“作废聘用”处理
  private async employHandle(v) {
    if (v === 0 || v === 1) {
      try {
        await this.$confirm(
          "请确认已完成选拔等环节；若聘用状态已确定需调整，请先作废后再操作，否则可能失败。是否继续？",
          "提示",
          { type: "warning", confirmButtonText: "继续", cancelButtonText: "取消" }
        );
      } catch (e) {
        return;
      }
    }
    //操作校验
    // 之前的流程
    // if (!this.operationCheck()) return false;
    // let params = {
    //   employState: v, //聘用状态 0:确认 1:作废
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId, //项目id
    //   subjectId: this.subjectId //科目id
    // }

    // 现在的流程
    let resArr = await this.handleParams(v);
    if (!resArr) return false;
    try {
      this.fullscreenLoading = true;
      await updateEmployStatus(resArr);
      this.fullscreenLoading = false;
      this.$message.success("操作成功");
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      this.$message.error(error || "操作失败");
      // this[`$message`]({
      //   type: "error",
      //   message: error!.mesg ? error!.mesg : error
      // });
    }
  }

  //“生成聘书”处理
  private async generateHandle() {
    //操作校验
    // 之前流程
    // if (!this.operationCheck()) return false;
    // let params = {
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId, //项目id
    //   subjectId: this.subjectId //科目id
    // };
    // 现在流程
    let resArr = await this.handleParams();
    if (!resArr) return false;
    try {
      await createOffer(resArr);
      this.$message.success("操作成功");
      this.getData();
    } catch (error) {
      this.$message.error(error || "操作失败");
      //   this[`$message`]({
      //     type: "error",
      //     message: error!.mesg ? error!.mesg : error
      //   });
    }
  }

  //“开放查看”处理
  private async openViewHandle() {
    //操作校验
    // 之前流程
    // if (!this.operationCheck()) return false;
    // let params = {
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId, //项目id
    //   subjectId: this.subjectId //科目id
    // };

    // 现在流程
    let resArr = await this.handleParams();
    if (!resArr) return false;
    try {
      await openCheck(resArr);
      this.$message.success("操作成功");
      this.getData();
    } catch (error) {
      this.$message.error(error || "操作失败");
      // this[`$message`]({
      //   type: "error",
      //   message: error!.mesg ? error!.mesg : error
      // });
    }
  }

  //“正式发布聘用”处理
  private async releaseHandle() {
    //操作校验
    // 之前流程
    // if (!this.operationCheck()) return false;
    // let params = {
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId, //项目id
    //   subjectId: this.subjectId //科目id
    // };

    // 现在流程
    let resArr = await this.handleParams();
    if (!resArr) return false;
    try {
      await formalReleaseEmploy(resArr);
      this.$message.success("操作成功");
      this.getData();
    } catch (error) {
      this.$message.error(error || "操作失败");
      // this[`$message`]({
      //   type: "error",
      //   message: error!.mesg ? error!.mesg : error
      // });
    }
  }
  private goBack(){
    // 释放文件引用
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }

    this.$refs['iframeContainer'].removeChild(this.iframe);
    this.iframe = null;
  }

//预览pdf
 private previewPDF(res){
    //创建一个iframe
    this.iframe = document.createElement("iframe");
    this.iframe.setAttribute("frameborder", 0);
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.$refs['iframeContainer'].appendChild(this.iframe);
    this.iframe.src = window.URL.createObjectURL(res);
  }
  private clearSelection(){
    this.$refs['table'].clearSelection()
  }
  //打印聘书处理
  private async printHandle() {
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选一条记录！");
      return false;
    }

    let arr = this.chooseRowArray.map(item => {
      return {
        projectId: item[`projectId`], // 项目id
        subjectId: item[`subjectId`], //科目id
        teacherId: item[`teacherId`] // 教师id
      }
    });

    try {
      const response = await printOffer(arr);
      this.clearSelection(); //清空选择

      // 1. 直接从响应中获取blob对象（不需要new Blob()包装）
      const blob = response;

      // 2. 创建对象URL
      const url = URL.createObjectURL(blob);

      // 3. 创建下载链接
      const link = document.createElement('a');
      link.href = url;
      link.download = '聘书.pdf'; // 更合理的文件名

      // 4. 触发下载
      document.body.appendChild(link);
      link.click();

      // 5. 清理资源
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url); // 释放内存
      }, 100);
      // ====================================

    } catch (error) {
      this.clearSelection(); //清空选择
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //关闭聘书处理
  private closeContract() {
    this.showContract = false;
    //刷新列表
    this.getData();
  }

  // 打印 方法
  private async chooseDownloadHandle(res, fileFullName) {
    try {
      const blob: Blob = new Blob(
        [res],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        }
        // {type: 'application/pdf;charset=UTF-8'}
      );
      const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      const downloadElement = document.createElement("a");
      const href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = fileFullName; // 下载后文件名 单位管理模板.xlsx
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
      this.$message.success("下载成功");
    } catch (error) {
      this.$message.error(error || "下载失败");
      // this[`$message`]({
      //   type: "error",
      //   message: error!.mesg ? error!.mesg : error
      // });
    }
  }

  //“导出”处理
  private exportHandle() {
    (this as any).downloadHandle(
      "exportMarkingEmployManage",
      "评卷聘用管理.xlsx",
      this.getRequestParams()
    );
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
